import styled from 'styled-components';
import {theme} from '@styles/theme';

export const SystemPlanDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: ${theme.roundedMedium};
  overflow: hidden;
  button {
    padding: 8px;
  }
`;
